import { io, type Socket } from "socket.io-client";
import type { ClientToServerEvents, ServerToClientEvents } from "../types/protocol";
import { getAccessToken } from "./api";

export type SkyjoSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

const endpoint = import.meta.env.VITE_SERVER_URL?.trim() || undefined;

export const socket: SkyjoSocket = io(endpoint, {
  // Fonction et non objet figé : chaque reconnexion relit le jeton courant.
  auth: (cb) => cb({ token: getAccessToken() ?? undefined }),
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 700,
  reconnectionDelayMax: 5_000,
  timeout: 8_000,
});
